














import Vue from "vue";
import ConnectedDeviceForm from "./ConnectedDeviceForm.vue";
import { ConnectedDeviceService } from "@/services/ConnectedDeviceService";
import { ConnectedDevice } from "../../models/ConnectedDevice";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      default: false
    },
    selectedDevice: {
      type: Object as () => ConnectedDevice,
      default: null
    }
  },
  data() {
    return {
      modalVisible: this.value,
      saving: false,
      settingData: {
        id: 0,
        ipAddress: "",
        isAuthorized: false,
        isConnected: false,
        mode: 0,
        appBuildNumber: "",
        appVersison: "",
        baseOrderNumber: 0,
        deviceName: "",
        deviceUDID: "",
        iPDescription: "",
        isRegisterAtSlave: false,
        isSelf: false,
        portNumber: 0
      } as ConnectedDevice
    };
  },
  components: {
    ConnectedDeviceForm
  },
  methods: {
    async handleSubmit(data) {
      try {
        this.saving = true;
        await ConnectedDeviceService.AddConnectedDevices(this.selectedDevice.deviceUDID, this.settingData);
        this.modalVisible = false;
        this.$emit("addSuccess", this.settingData);
        this.settingData = {
          id: 0,
          ipAddress: "",
          isAuthorized: false,
          isConnected: false,
          mode: 0,
          appBuildNumber: "",
          appVersison: "",
          baseOrderNumber: 0,
          deviceName: "",
          deviceUDID: "",
          iPDescription: "",
          isRegisterAtSlave: false,
          isSelf: false,
          portNumber: 0
        } as ConnectedDevice;
      } catch (error) {
        this.showErrorMessage(error);
      } finally {
        this.saving = false;
      }
    }
  },
  watch: {
    value(newValue) {
      this.modalVisible = newValue;
    },
    modalVisible(newValue) {
      this.$emit("input", newValue);
    }
  }
});
